import SearchHit from 'components/helpers/AlgoliaSearch/SearchHit';
import { Configure, Hits, useConnector } from 'react-instantsearch-hooks-web';
import connectStats from 'instantsearch.js/es/connectors/stats/connectStats';
import { Field, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import type {
  StatsConnectorParams,
  StatsWidgetDescription,
} from 'instantsearch.js/es/connectors/stats/connectStats';
import { CustomPagination } from './CustomPagination';
import classNames from 'classnames';
import { defaultFilter } from './util';
import RichTextA11yWrapper from '../RichTextA11yWrapper';
import { isEmployeeBlog } from 'lib/util/employee-blog-utils';

export type UseStatsProps = StatsConnectorParams;

function useStats(props?: UseStatsProps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useConnector<StatsConnectorParams, StatsWidgetDescription>(connectStats as any, props);
}

interface IMyProps {
  isRitn?: boolean;
  dropdownFilters: string[];
  noResultsHelpText: Field<string>;
}

const SearchResultsWithSearch = (
  { isRitn, dropdownFilters, noResultsHelpText }: IMyProps,
  props: UseStatsProps
) => {
  const { nbHits } = useStats(props);
  const ifConfigure = !!dropdownFilters?.length;
  const configureFilters = `${defaultFilter()} AND type:`;
  const filterstring = configureFilters.concat(dropdownFilters.join(' OR type:'));
  const showPagination = nbHits > 10;

  return (
    <div className={classNames({ ritn: isRitn })}>
      {ifConfigure && <Configure analytics={false} filters={filterstring} hitsPerPage={10} />}
      {nbHits < 1 && !isRitn ? (
        <div>
          <RichTextA11yWrapper
            className={classNames('text-blue-navy', 'mb-2', 'mt-4')}
            field={noResultsHelpText}
          />
        </div>
      ) : (
        <></>
      )}
      <div>
        <Hits hitComponent={SearchHit} />
      </div>
      <div className={classNames({ hidden: !showPagination })}>
        <CustomPagination padding={1} />
      </div>
    </div>
  );
};

const SearchResults = (
  { isRitn, dropdownFilters, noResultsHelpText }: IMyProps,
  props: UseStatsProps
) => {
  const { sitecoreContext } = useSitecoreContext();
  const employeeBlog = isEmployeeBlog(sitecoreContext);
  const finalFilters = employeeBlog ? ['article'] : dropdownFilters;
  const pageEditing = sitecoreContext.pageEditing === true;
  if (pageEditing) {
    return (
      <div className={classNames({ ritn: isRitn })}>
        <div>Search Results will be shown here</div>
      </div>
    );
  }
  return (
    <SearchResultsWithSearch
      isRitn={isRitn}
      dropdownFilters={finalFilters}
      noResultsHelpText={noResultsHelpText}
      {...props}
    />
  );
};

export default SearchResults;
